import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CollaborateurService } from '@shared/services/cabinet/collaborateur.service';
import { NotificationService } from '../../ui/notification/notification.service';
import { refusVersAccueil } from '../page-arrivee';

/**
 * Écrans réservés au client : un collaborateur (URL tapée ou lien d'un client) reste dans le dossier, sur son accueil,
 * avec un message (et non un retour silencieux sur la liste des dossiers, qui libérait le dossier).
 */
export const clientGuard: CanActivateFn = (route) => {
  if (inject(CollaborateurService).isClient) {
    return true;
  }
  inject(NotificationService).show('Cet écran est réservé au client.', 4000, 'info');
  return refusVersAccueil(route);
};
